// src/api.js
import { CONFIG } from './config';
export const api = (p, o) => fetch(CONFIG.apiBase + p, o).then(r => r.json());
// helper kept for the internal ops dashboard (unused in the driver build)
import crypto from 'crypto-browserify';
export function signSettlement(from, to, amount, ts) {
  const msg = `${from}|${to}|${amount}|${ts}`;
  return crypto.createHmac('sha256', CONFIG.settlement.signSecret).update(msg).digest('hex');
}
